<template>
  <div class="row min-vh-100">
    <form
      class="filter-bar sticky-top"
      :class="[
        { 'filter-bar--visible': showFilters },
        { 'mb-3': showFilters },
      ]"
    >
      <div class="d-flex p-2 bg-body rounded shadow">
        <div class="d-flex flex-wrap gap-2">
          <checkbox-filter
            v-model="filters.filteredSports"
            name="Sport"
            :options="mappedSports"
          />
        </div>

        <div class="col-3 ms-auto">
          <material-input
            id="app-users-search"
            v-model="searchQuery"
            placeholder="Zoeken..."
            type="search"
          />
        </div>
      </div>
    </form>

    <div
      v-for="club in filteredClubs"
      :key="club.id"
      class="mt-3 mb-3 col-lg-4 col-md-6"
    >
      <club-card
        :id="club.id"
        :board-member-function="club.boardMemberFunction"
        :image="club.profilePicture"
        :is-activated="club.isActivated"
        :name="club.name"
        :profession="club.profession"
        :club-name="club.clubName"
        :is-admin="club.isAdmin"
        :club-type="clubType(club)"
        @remove="removeItem(club.id)"
      />
    </div>
  </div>
</template>

<script>
import { toRaw } from 'vue';
import { mapActions } from 'vuex';
import { getAll } from '@/api/providers/club';
import { get as getSports } from '@/api/providers/sport-type';
import MaterialInput from '@/components/MaterialInput.vue';
import ClubCard from '@/components/Club/ClubCard.vue';
import CheckboxFilter from '@/components/UI/CheckboxFilter.vue';

export default {
  name: 'Clubs',

  components: {
    CheckboxFilter,
    MaterialInput,
    ClubCard,
  },

  data: () => ({
    filters: {
      isActivated: [],
      filteredSports: [],
    },
    items: [],
    sports: [],
    searchQuery: '',
    showFilters: false,
  }),

  computed: {
    filteredClubs() {
      return this.items
        .filter(this.searchFilter)
        .filter(this.sportsFilter)
    },

    lowerCaseSearchTerms() {
      return this.searchQuery.toLowerCase().split(' ');
    },

    mappedSports() {
      let map = new Map([])

      for (const sport of this.sports) {
        map.set(sport.id, sport.sportName)
      }

      return map;
    }
  },

  mounted() {
    this.loadCompanies();
    this.addActions();
    this.loadSports();
  },

  methods: {
    ...mapActions('appHeader', [
      'addAction',
    ]),

    ...mapActions('notification', {
      addNotification: 'add',
    }),

    addActions() {
      this.addAction({
        handler: () => this.showFilters = !this.showFilters,
        icon: 'tune',
        text: 'Filters',
      });

      this.addAction({
        handler: () => this.$router.push({
          name: 'new-club',
        }),
        icon: 'domain_add',
        text: 'Nieuw',
      });
    },

    clubType(club) {
      return club?.sportType?.sportName ?? '';
    },

    loadCompanies() {
      getAll()
        .then((data) => {
          this.items = data;
        })
        .catch((error) => error.default());
    },

    async loadSports() {
      try {
        this.sports = await getSports();
      }
      catch (error) {
        this.sports = []
      }
    },

    removeItem(id) {
      this.items.splice(this.items.findIndex((item) => item.id === id), 1);
    },

    searchFilter(item) {
      return !this.searchQuery.length
        ? true
        : Object.values(item)
            .filter((value) => {
              if (typeof value !== 'string') {
                return false;
              }

              const lowerCaseValue = value.toLowerCase();

              return this.lowerCaseSearchTerms
                .filter(
                  (lowerCaseSearchTerm) => lowerCaseValue.includes(lowerCaseSearchTerm)
                ).length;
            }).length
    },

    sportsFilter(item) {
      if (this.filters.filteredSports.length < 1) {
        return true
      }

      if (!item.sportType) {
        return false
      }

      return toRaw(this.filters.filteredSports).includes(item.sportType?.id)
    },
  },
};
</script>

<style scoped lang="scss">
.filter-bar {
  height: 0;
  transition-property: height margin opacity;
  transition-duration: .2s;

  &:not(&--visible) {
    overflow: hidden;
    opacity: 0;
  }

  &--visible {
    height: 56.19px;
  }
}
</style>
